import React from "react";
import PaymentPlans from "../../home/components/payment-plans";
import Payment from "home/containers/payment";
import PaymentInformation from "home/components/payment-information";
import PaymentDocuments from "home/containers/payment-documents";
import AccountHistory from "home/containers/account-history";
import LinkPaymentMethod from "../../home/containers/link-payment-method";
import DeletePaymentMethod from "home/containers/delete-payment-method";
import SignDocuments from "home/containers/sign-documents";
import BankAccountAchMessage from "../../home/components/bank-account-ach-message";
import ActivePaymentPlan from '../containers/active-payment-plan';
import "./home-layout.css";

function HomeLayout(props) {
  // MODAL DIALOGS (One instance only) ---------------
  const newPayment = props.visibility.Payment ? (
    <Payment
      handleShow={props.handleShow}
      currentPlan={props.Payment.currentPlan}
      paymentMethods={props.Payment.paymentMethods}
    />
  ) : null;

  const paymentInformation = props.visibility.PaymentInformation ? (
    <PaymentInformation
      handleShow={props.handleShow}
      confirmation={props.PaymentInformation.confirmation}
    />
  ) : null;

  const accountHistory = props.visibility.AccountHistory ? (
    <AccountHistory
      handleShow={props.handleShow}
      currentPlan={props.AccountHistory.currentPlan}
    />
  ) : null;

  const accountSetup = props.docsToSign ? (
    <SignDocuments handleShow={props.handleShow} documents={props.docsToSign} />
  ) : null;

  const paymentDocuments = props.visibility.PaymentDocuments ? (
    <PaymentDocuments
      handleShow={props.handleShow}
      currentPlan={props.PaymentDocuments.currentPlan}
    />
  ) : null;

  const achMessage = props.visibility.BankAccountAchMessage ? (
    <BankAccountAchMessage handleShow={props.handleShow} />
  ) : null;

  const linkPaymentMethod = props.visibility.LinkPaymentMethod ? (
    <LinkPaymentMethod
      show={true}
      handleShow={props.handleShow}
      handleUpdateAch={props.handleUpdateAch}
      currentPlan={props.LinkPaymentMethod.currentPlan}
      addPaymentMethod={props.LinkPaymentMethod.addPaymentMethod}
    />
  ) : null;

  const deletePaymentMethod = props.visibility.DeletePaymentMethod ? (
    <DeletePaymentMethod
      handleShow={props.handleShow}
      paymentMethod={props.DeletePaymentMethod.currentPaymentMethod}
      currentPlan={props.DeletePaymentMethod.currentPlan}
      removePaymentMethod={props.DeletePaymentMethod.removePaymentMethod}
    />
  ) : null;

  // ---- END MODALS (TODO: Extract to a shared library) ----------
  return (
    <div className="home">
      {props.activePlans && props.activePlans.length > 0 ? (
        <div className="active">
          <h3>Active Payments</h3>
          {props.activePlans.map(plan => (
            <div key={plan.paymentId}>
              <ActivePaymentPlan
                plan={plan}
                achNeedsVerification={props.achNeedsVerification}
                justVerifiedAccount={props.justVerifiedAccount}
                handleClickArrow={props.handleClickArrow}
                showPaymentDetails={props.showPaymentDetails[plan.paymentId]}
                handleShow={props.handleShow}
                showVerificationDialog={props.showVerificationDialog}
              />
            </div>
          ))}

          <span className="modals">
            {newPayment}
            {paymentInformation}
            {accountSetup}
            {achMessage}
            {linkPaymentMethod}
            {deletePaymentMethod}
          </span>
        </div>
      ) : null}

      {props.completedPlans && props.completedPlans.length > 0 ? (
        <div className="paid">
          <h3>Completed Payments</h3>

          {props.completedPlans.map(plan => (
            <PaymentPlans
              key={plan.paymentId}
              plan={plan}
              handleShow={props.handleShow}
            />
          ))}
        </div>
      ) : null}

      {props.canceledPlans && props.canceledPlans.length > 0 ? (
        <div className="canceled">
          <h3>Canceled Payments</h3>

          {props.canceledPlans.map(plan => (
            <PaymentPlans
              key={plan.paymentId}
              plan={plan}
              handleShow={props.handleShow}
            />
          ))}
        </div>
      ) : null}

      {props.defaultedPlans && props.defaultedPlans.length > 0 ? (
        <div className="defaulted">
          <h3>Defaulted Payments</h3>

          {props.defaultedPlans.map(plan => (
            <PaymentPlans
              key={plan.paymentId}
              plan={plan}
              handleShow={props.handleShow}
            />
          ))}
        </div>
      ) : null}

      {paymentDocuments}
      {accountHistory}
    </div>
  );
}

export default HomeLayout;



// WEBPACK FOOTER //
// ./src/home/components/home-layout.js